import { DataType } from './data-type';

/**
 * Saved-query payload types served by dash-meta / report-builder APIs.
 * Kept here so `libs/core` stays independent of Nest apps.
 */
export type SavedQueryDataType =
  | 'ONE_DIMENSION'
  | 'TWO_DIMENSION'
  | 'TIMESERIES'
  | 'MAP'
  | 'TABLE';

/**
 * Maps a DataType to Snowflake saved-query `dataType` values that can
 * materialize that shape in the custom-query pipeline.
 */
export function dataTypeToSavedQueryDataTypes(
  dataType: DataType
): SavedQueryDataType[] {
  switch (dataType) {
    case DataType.SINGLE:
      return ['ONE_DIMENSION'];
    case DataType.BREAKDOWN_SINGLE:
    case DataType.FLOW_BREAKDOWN_SINGLE:
      return ['TWO_DIMENSION'];
    case DataType.TIMESERIES:
    case DataType.BREAKDOWN_TIMESERIES:
      return ['TIMESERIES'];
    case DataType.MAP:
      return ['MAP'];
    case DataType.TABLE_ROWS:
      return ['TABLE', 'ONE_DIMENSION', 'TWO_DIMENSION', 'TIMESERIES', 'MAP'];
    case DataType.BOX:
    case DataType.DISTRIBUTION:
    case DataType.TEXT:
      return [];
  }
}
